import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpenOTPConfirmPopup: false,
  phone: null,
  // payloadUpsertOTPConfirm:{}
};

const slice = createSlice({
  name: "commons",
  initialState,
  reducers: {
    openOTPPopup(state, action) {
      state.isOpenOTPConfirmPopup = true;
      state.phone = action.payload;
      // state.payloadUpsertOTPConfirm = action.payload;
    },
    closeOTPPopup(state, action) {
      state.isOpenOTPConfirmPopup = false;
      state.phone = null;
    },
  },
});

export const { openOTPPopup, closeOTPPopup } = slice.actions;
export default slice.reducer;
